/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Playlist } from './playlist';

export enum LibraryTopic {
  EVENTFAMILY = 'EVENTFAMILY',
  EVENT = 'EVENT',
  TEMPO = 'TEMPO'
}

export interface EventFamily {
  /**
   * Color as hexa format #FFFFFF
   */
  artwork?: string;
  backgroundColor?: string;
  color?: string;
  /**
   * Note used
   */
  exportable?: boolean;
  events?: Array<Playlist>;
  /**
   * Icon file name
   */
  icon?: string;
  /**
   * The database ID
   */
  id?: string;
  /**
   * This date is set server side to make the object available or not for the next Sync
   */
  libraryTopicType?: LibraryTopic;

  localUpdateDate?: Date;
  /**
   * Flag to identify the Event family to store custom playlits
   */
  myPlaylist?: boolean;
  /**
   * Playlist Family name
   */
  name?: string;

  playlists?: number;
  tracks?: number;
  /**
   * this date is set server side when the object is updated from the app
   */
  remoteUpdateDate?: Date;
  /**
   * Allow this family to be use in the search tab
   */
  useForDjSet?: boolean;
  mediasCount?: number;
  eventsCount?: number;
  duration?: number;
}
